import { type ReactNode, useState } from 'react'
import { confirmer } from './confirmation'

/** Section de fiche avec titre, contenu et, si autorisé, un formulaire d'ajout dépliable. */
export function Section({
  titre,
  children,
  ajout,
  libelleAjout = 'Ajouter',
}: {
  titre: string
  children: ReactNode
  ajout?: ((fermer: () => void) => ReactNode) | undefined
  libelleAjout?: string
}) {
  const [ouvert, setOuvert] = useState(false)
  return (
    <section className="carte section">
      <div className="section-titre">
        <h2>{titre}</h2>
        {ajout && !ouvert && (
          <button type="button" className="bouton-discret" onClick={() => setOuvert(true)}>
            {libelleAjout}
          </button>
        )}
      </div>
      {ajout && ouvert && <div className="section-ajout">{ajout(() => setOuvert(false))}</div>}
      {children}
    </section>
  )
}

/** Ligne affichable qui bascule en formulaire de modification. */
export function Ligne({
  children,
  edition,
  onSupprimer,
}: {
  children: ReactNode
  edition?: ((fermer: () => void) => ReactNode) | undefined
  onSupprimer?: (() => Promise<unknown>) | undefined
}) {
  const [edite, setEdite] = useState(false)
  const [erreur, setErreur] = useState<string | null>(null)
  if (edite && edition)
    return <div className="ligne ligne-edition">{edition(() => setEdite(false))}</div>
  return (
    <div className="ligne">
      <div className="ligne-contenu">{children}</div>
      <div className="ligne-actions">
        {edition && (
          <button type="button" className="bouton-discret" onClick={() => setEdite(true)}>
            Modifier
          </button>
        )}
        {onSupprimer && (
          <button
            type="button"
            className="bouton-discret"
            onClick={async () => {
              if (!(await confirmer('Supprimer cet élément ?'))) return
              try {
                setErreur(null)
                await onSupprimer()
              } catch (e) {
                setErreur(e instanceof Error ? e.message : 'Suppression impossible.')
              }
            }}
          >
            Supprimer
          </button>
        )}
      </div>
      {erreur && <p className="alerte">{erreur}</p>}
    </div>
  )
}

export function Vide({ children }: { children: ReactNode }) {
  return <p className="discret">{children}</p>
}
